import { render, staticRenderFns } from "./EmissionsAtmosphericAir.vue?vue&type=template&id=264e31f1&"
import script from "./EmissionsAtmosphericAir.vue?vue&type=script&lang=js&"
export * from "./EmissionsAtmosphericAir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports